import { Bank, DjangoBank, parseBank } from './bank.model';

export enum BANK_ACCOUNT_TYPES {
  SAVING_ACCOUNT = 'SAVING_ACCOUNT',
  CHECKING_ACCOUNT = 'CHECKING_ACCOUNT',
  SALARY_ACCOUNT = 'SALARY_ACCOUNT',
}

export const BANK_ACCOUNT_TYPES_MAP = Object.keys(BANK_ACCOUNT_TYPES).map((bankAccountType) => ({
  key: bankAccountType,
  value: BANK_ACCOUNT_TYPES[bankAccountType],
}));

export class BankAccount {
  id: string;
  bank: Bank;
  branchNumber: string;
  checkingAccount: string;
  checkingAccountDigit: string;
  bankAccountType: BANK_ACCOUNT_TYPES;

  constructor(data: string | BankAccount | DjangoBankAccount = {}) {
    if (data instanceof BankAccount) {
      bindBankAccountData(this, data);
    } else if (typeof data === 'string') {
      bindDjangoBankAccountData(this, { id: data });
    } else {
      bindDjangoBankAccountData(this, data);
    }
  }

  get djangoModel() {
    return getDjangoModel(this);
  }
}

export function parseBankAccount(data?: string | BankAccount | DjangoBankAccount) {
  if (data) {
    return new BankAccount(data);
  } else {
    return undefined;
  }
}

function bindBankAccountData(bankAccount: BankAccount, data: BankAccount) {
  bankAccount.id = data.id;
  bankAccount.bank = parseBank(data.bank);
  bankAccount.branchNumber = data.branchNumber;
  bankAccount.checkingAccount = data.checkingAccount;
  bankAccount.checkingAccountDigit = data.checkingAccountDigit;
  bankAccount.bankAccountType = data.bankAccountType;
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoBankAccount {
  id?: string;
  bank?: string | DjangoBank;
  branch_number?: string;
  checking_account?: string;
  checking_account_digit?: string;
  account_type?: BANK_ACCOUNT_TYPES;
}

function bindDjangoBankAccountData(bankAccount: BankAccount, data: DjangoBankAccount) {
  bankAccount.id = data.id;
  bankAccount.bank = parseBank(data.bank);
  bankAccount.branchNumber = data.branch_number;
  bankAccount.checkingAccount = data.checking_account;
  bankAccount.checkingAccountDigit = data.checking_account_digit;
  bankAccount.bankAccountType = data.account_type;
}

function getDjangoModel(bankAccount: BankAccount): DjangoBankAccount {
  return {
    id: bankAccount.id,
    bank: bankAccount.bank.id,
    branch_number: bankAccount.branchNumber,
    checking_account: bankAccount.checkingAccount,
    checking_account_digit: bankAccount.checkingAccountDigit,
    account_type: bankAccount.bankAccountType,
  };
}
